import type { Size, Target, DataAttrs } from '@uikit/types';

export interface Props {
    classes?: string;
    isUnderline?: boolean;
    isDottedUnderline?: boolean;
    isDisabled?: boolean;
    href?: string | null;
    attrs?: Partial<Attrs> | null;
    el?: HTMLSpanElement | HTMLAnchorElement | null;
    size?: Size;
    isBold?: boolean;
    offVisited?: boolean;
    withIconLeft?: boolean;
    withIconRight?: boolean;
    target?: Target | null;
    color?: Color;
    style?: string;
}

interface Attrs extends DataAttrs {
    target: Target;
    name: string;
    title: string;
    hreflang: string;
    rel: string;
    ping: string;
    tabindex: number;
}

export enum Color {
    Primary = 'primary',
    Secondary = 'secondary',
    Brand = 'brand',
    Disabled = 'disabled',
    Invert = 'invert',
    Unset = 'unset',
}
